import styles from "./errormessage.module.scss";

type FormElementErrorMessageProps = {
  message?: string;
};

const FormElementErrorMessage = ({
  message = ""
}: FormElementErrorMessageProps) => (
  <div className={styles["error-msg"]}>{message}</div>
);

export default FormElementErrorMessage;
